import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-sms-icon',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './sms-icon.component.html',
	styleUrl: './sms-icon.component.scss',
})
export class SmsIconComponent {
	@Input() fallbackUsed: boolean = false;
}
